
import Vue from "vue";
import { Component, Provide } from "vue-property-decorator";
import { configStore, singularityStore, uiStore } from "@/store/store";
import ControlsTree from "@/components/Reusable/ControlsTree/ControlsTree.vue";
import { editingElementControlsTreeContext } from "@/lib/components/controls";
import SingularityPanelHeader from "@/components/Singularity/PanelHeader/SingularityPanelHeader.vue";

@Component({
  components: {
    ControlsTree,
    SingularityPanelHeader
  }
})
export default class ContentPropertiesEditor extends Vue {
  get contentSections() {
    if (!uiStore.activeElement) return null;
    return configStore.element(uiStore.activeElement.data.type).controls
      .contentSections;
  }

  @Provide("context")
  editingElementControlsTreeContext = editingElementControlsTreeContext;

  get contentPropertiesEditorPanelState() {
    return singularityStore.contentPropertiesEditorPanelState;
  }

  get panelTitle() {
    if (!uiStore.activeElement) {
      return null;
    }
    return configStore.element(
      uiStore.activeElement.data.type
    ).name;
  }
}
